export default "__VITE_ASSET__BkHCQB1a__"